import { css } from "@emotion/react";

import { colors } from "@styles";

export const marketingLinkColor = css`
  color: ${colors.green.darkFamily.normal};

  &:hover {
    color: ${colors.green.darkFamily.darker};
  }
`;
